module.exports = __webpack_public_path__ + "static/media/alarm3.d3b1f48f.svg";